export default {
	nameFieldLabel: "KR name",
	nameFieldHint: "Short, clear, aspirational, and achievable within a given cycle.",
	nameFieldPlaceholder: "e.g. Sell 100,000 widgets",
	confidenceLevelFieldLabel: "Confidence",
	confidenceLevelFieldHint: "Your level of confidence that this key result will be completed on time.",
	typeFieldLabel: "KR type",
	typeFieldHint: "Choose from numeric, currency, percentage, or binary.",
	binaryFieldLabel: "Status",
	currentValueFieldLabel: "Current value",
	targetValueFieldLabel: "Target value",
	startDateFieldLabel: "Start date",
	endDateFieldLabel: "End (target) date",
	ownerIdFieldLabel: "Owner",
	ownerIdFieldHint: "The person responsible for this result.",
	parentGoalFieldLabel: "Parent Goal",
	commentFieldLabel: "Comment",
	commentFieldOptionalLabel: "Optional",
	commentFieldHint: "Add a comment to give context to any changes you make. Comments appear in activity feeds for this KR and its parent goal.",
	commentFieldPlaceholder: "Leave a comment",
};
